import script from "./ChangePasswordDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./ChangePasswordDialog.vue?vue&type=script&setup=true&lang=js"

import "./ChangePasswordDialog.vue?vue&type=style&index=0&id=d12992d8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d12992d8"]])

export default __exports__